import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1 } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";

const CompletionTimePlot = ({ recordings }) => {
  const [positions, setPositions] = useState([]);
  const [completionTimesValues, setCompletionTimesValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    const positionsArray = [];
    const valuesArray = [];
    let visibleLabels = [];
    let counter = 1;

    recordings.forEach((recording, index) => {
      if (recording.hasOwnProperty("completionTimes")) {
        const completionValues = Object.values(recording.completionTimes).flat();
        valuesArray.push(...completionValues);

        for (let i = 0; i < completionValues.length - 1; i++) {
          positionsArray.push(index);
          visibleLabels.push("");
        }
        positionsArray.push(index);
        visibleLabels.push(counter.toString());
        counter++;
      } else {
        positionsArray.push(index);
        valuesArray.push(NaN);
        visibleLabels.push(counter.toString());
        counter++;
      }
    });

    setPositions(visibleLabels);
    setCompletionTimesValues(valuesArray);

    return () => {
      setPositions([]);
      setCompletionTimesValues([]);
    };
  }, [recordings]);

  const data = {
    labels: positions,
    datasets: [
      {
        label: t("reports.learnabilityGraphic.title"),
        data: completionTimesValues,
        backgroundColor: graphicDataColor1,
        borderColor: graphicDataColor1,
        spanGaps: true,
      },
    ],
  };

  return (
    <Graphic
      Title={t("reports.learnabilityGraphic.title")}
      Type={Line}
      data={data}
      axisY={t("reports.learnabilityGraphic.title")}
      axisX={t("reports.learnabilityGraphic.axisX")}
      paramScales={{
        x: {
          ticks: {
            autoSkip: false,
            maxRotation: 0,
          },
        },
        y: {
          beginAtZero: true,
        },
      }}
    />
  );
};

export default CompletionTimePlot;
